/**
 * Case-insensitive comparison of two currency codes. Returns false when either is missing,
 * so an unknown currency is never treated as "the system currency".
 */
export const isSameCurrency = (
  first?: string | null,
  second?: string | null,
): boolean => {
  const a = first?.trim();
  const b = second?.trim();
  if (!a || !b) return false;
  return a.toLowerCase() === b.toLowerCase();
};

/**
 * The currency a new document is converted *from* when its exchange rate is refreshed.
 * Amounts are stored in the system currency, so the rate is always system -> document currency,
 * never previous document currency -> document currency.
 */
export const getExchangeRateFromCurrency = (
  documentSystemCurrency?: string | null,
  sessionSystemCurrency?: string | null,
): string | undefined => {
  return documentSystemCurrency || sessionSystemCurrency || undefined;
};
